import { Paper, Typography } from "@mui/material";

const LiveScore = ({ name, score }) => {
  return (
    <Paper
      sx={{
        width: "fit-content",
        textAlign: "center",
        padding: "0.3rem 0.5rem",
        borderRadius: "4px",
      }}
      elevation={4}
    >
      <Typography variant="form_h1" sx={{ width: "100%", textAlign: "center" }}>
        {name} score : {score}
      </Typography>
    </Paper>
  );
};

export default LiveScore;
